import { render, staticRenderFns } from "./AuxiliaryApproversAdd.vue?vue&type=template&id=78f12d62&scoped=true&"
import script from "./AuxiliaryApproversAdd.vue?vue&type=script&lang=js&"
export * from "./AuxiliaryApproversAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f12d62",
  null
  
)

export default component.exports